import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { AppSettings } from "./AppSettings";
import { StorageService } from "./StorageService";
@Injectable()
export class HttpService {
  constructor(private readonly http: HttpClient, private localStorage: StorageService) {
  }
  get<TResponse>(apiEndPoint: string, request?: any, auth: boolean = false): Observable<TResponse> {

    if (auth == true) {
      let token = localStorage.getItem("token");
      let headers = new HttpHeaders({ 'Authorization': token, 'Accept': 'application/json' });
      return this.http.get<TResponse>(AppSettings.baseUrl() + apiEndPoint, { headers: headers, withCredentials: true });
    }
    else {
      let headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      return this.http.get<TResponse>(AppSettings.baseUrl() + apiEndPoint, { headers: headers, params: request });
    }

  }

  getByUrl<TResponse>(url: string): Observable<any> {

    return this.http.get<TResponse>(AppSettings.baseUrl() + url)
  }

  post<TResponse>(apiEndPoint: string, request: any, auth: boolean = false): Observable<TResponse> {

    if (auth == true) {
      let token = localStorage.getItem("token");
      return this.http.post<TResponse>(AppSettings.baseUrl() + apiEndPoint, request,
        {
          headers: new HttpHeaders({ "Authorization": "Bearer " + token, "Content-Type": "application/json" }),
          withCredentials: true
        });
    }
    else {
      let headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      return this.http.post<TResponse>(AppSettings.baseUrl() + apiEndPoint, request, { headers: headers });
    }
  }

  getExternalUrl<TResponse>(url: string): Observable<any> {

    return this.http.get<TResponse>(url)
  }
}








//export class HttpService {
//    constructor(private readonly http: HttpClient) {
//    }
//    get<TResponse>(apiEndPoint: string, request?: any, auth: boolean = true): Observable<TResponse> {
//        let headers = new HttpHeaders();
//        headers.append('Content-Type', 'application/json');
//        if (!auth) {
//            headers = headers.append("Auth", "False");
//        }
//        return this.http.get<TResponse>(AppSettings.baseUrl() +apiEndPoint, { headers: headers, params: request });
//    }

//    getByUrl<TResponse>(url: string): Observable<any> {

//        return this.http.get<TResponse>(AppSettings.baseUrl() + url)
//    }

//    post<TResponse>(apiEndPoint: string, request: any): Observable<TResponse> {
//        let headers = new HttpHeaders();
//        headers.append('Content-Type', 'application/json');     
//        return this.http.post<TResponse>(AppSettings.baseUrl() + apiEndPoint, request, { headers: headers });
//    }
//}
